import script from "./ChatMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessages.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessages.vue?vue&type=style&index=0&id=4797e564&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4797e564"]])

export default __exports__